/*    
 *  _________________________________________
 * / Stop right there, ya dingus. This file  \
 * \ should not be edited.                   /
 *  -----------------------------------------
 *  \
 *   \
 *      __
 *     /  \
 *     |  |
 *     @  @
 *     |  |
 *     || |/
 *     || ||
 *     |\_/|
 *     \___/
 *    
 * This file is automatically generated through https://localise.biz.
 *                                                                         
 * To update this file:
 *
 *  $ npm run update-language
 *
 * Last update:    Wed Jan 22 2025 15:40:47 GMT+0100 (Central European Standard Time)
 * Language keys:  2
 * Language code:  de
 *
 */

const language = {
  "button": {
    "continue": "Weitermachen"
  },
  "component": {
    "questionNumber": {
      "questionNumberCurrent": "Frage %{numberCurrent}",
      "questionNumberMax": "von %{numberMax}",
      "optional": " (Optional)"
    },
    "textInputBox": "Ich möchte hinzufügen …",
    "answerType": {
      "button": {
        "finishTheSurvey": "Beenden Sie die Umfrage",
        "continue": "Weitermachen"
      }
    },
    "finishSurveyDisplay": {
      "thanks": "Danke für das Feedback!",
      "explanation": "Dies hilft uns sehr, Ihre Sicherheit weiter zu verbessern."
    },
    "alert": {
      "error": "Beim Aktualisieren Ihrer Antworten ist ein Fehler aufgetreten. Versuchen Sie es bitte erneut."
    },
    "loading": {
      "loading": "Laden...",
      "cannotOpen": "Wir können die Umfrage nicht öffnen.",
      "openSurveyAgain": "Bitte schließen Sie die Registerkarte und öffnen Sie die Umfrage erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Support."
    }
  }
} as const

export default language